// extracted by mini-css-extract-plugin
export var leftAlign = "_2t-2";
export var popper = "_2t-0";
export var subtitle = "_2t-1";